/// <amd-module name="Environments/RunsCommon/Utils" />

export const Area = "EnvironmentDeployment";

export namespace FeatureNames {
    export const PipelineRunsView = "PipelineRunsView";
}

export namespace Action {
    export const EnvironmentTabNavigation = "EnvironmentTabNavigation";
    
}
